<button class="btn btn-sm btn-link"
        (click)="onContinue()">Continue</button>